import React from "react";

function ProjectVisual({ project, className = "" }) {
  if (project.image) {
    return (
      <img
        src={project.image}
        alt={project.imageAlt || `Aperçu du projet ${project.name}`}
        className={`h-full w-full object-contain p-2 sm:p-3 ${className}`}
      />
    );
  }

  return (
    <div
      className={`flex h-full w-full items-center justify-center bg-surfaceSoft/60 px-6 text-center ${className}`}
      aria-label={`Aperçu du projet ${project.name}`}
    >
      <div>
        <span className="mb-3 block text-xs font-semibold uppercase tracking-[0.24em] text-brandStrong">
          {project.type}
        </span>
        <span className="font-title text-3xl font-semibold text-brandDeep sm:text-4xl">
          {project.name}
        </span>
      </div>
    </div>
  );
}

export default ProjectVisual;
